<template>
  <el-select
    :value="value"
    :multiple="multiple"
    :filterable="filterable"
    :collapse-tags="collapseTags"
    :clearable="clearable"
    :placeholder="placeholder"
    :disabled="disabled"
    popper-class="dict-select-dropdown"
    style="width:100%"
    @input="onInput"
    @change="onChange"
  >
    <slot />
    <el-option
      v-if="!disabled"
      :value="ADD_VALUE"
      :label="addText"
      class="dict-add-option"
    >
      <span class="add-opt-text" @click.stop.prevent="onAdd">+ {{ addText }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { fetchNav } from '../api/auth'
import { hasMenuAccess } from '../utils/nav'

const ADD_VALUE = '__NAV_ADD__'

export default {
  name: 'SelectWithNavAdd',
  props: {
    value: { type: [String, Number, Array], default: null },
    multiple: { type: Boolean, default: false },
    filterable: { type: Boolean, default: true },
    collapseTags: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: '请选择' },
    disabled: { type: Boolean, default: false },
    addText: { type: String, default: '添加' },
    navPath: { type: String, default: '' },
    navPerms: { type: String, default: '' }
  },
  data() {
    return {
      ADD_VALUE,
      navMenus: null
    }
  },
  methods: {
    stripAdd(v) {
      if (this.multiple) {
        return (Array.isArray(v) ? v : []).filter(x => x !== ADD_VALUE)
      }
      return v === ADD_VALUE ? (this.value === ADD_VALUE ? null : this.value) : v
    },
    containsAdd(v) {
      if (this.multiple) return Array.isArray(v) && v.includes(ADD_VALUE)
      return v === ADD_VALUE
    },
    onInput(v) {
      if (this.containsAdd(v)) {
        // 由 onChange 处理添加，避免选中占位值
        this.$emit('input', this.stripAdd(v))
        return
      }
      this.$emit('input', v)
    },
    onChange(v) {
      if (this.containsAdd(v)) {
        this.$nextTick(() => {
          this.$emit('input', this.stripAdd(this.multiple ? (Array.isArray(this.value) ? this.value : []) : this.value))
        })
        this.onAdd()
        return
      }
      this.$emit('change', v)
    },
    async ensureNav() {
      if (this.navMenus) return this.navMenus
      const res = await fetchNav()
      this.navMenus = res.data || []
      return this.navMenus
    },
    async onAdd() {
      if (this.navPath || this.navPerms) {
        const menus = await this.ensureNav()
        if (!hasMenuAccess(menus, { path: this.navPath, perms: this.navPerms })) {
          return this.$message.warning(`没有权限，无法${this.addText}`)
        }
      }
      this.$emit('add')
    }
  }
}
</script>
